export default {
  Studies: "Зерттеулер",
  Layouts: "Терезелер",
  Sync: "Синхрондау",
  scroll: "Айналдыру",
  wwwc: "Деңгейлер",
  zoom: "Үлкейту",
  general: "Негізгі",
  zooming: "Үлкейту",
  annotation: "Өлшемдер",
  rotating: "Айналдыру",
  Pan: "Жылжыту",
  Wwwc: "Нүкте арқылы деңгейлер",
  WwwcRegion: "Көпбұрыш арқылы деңгейлер",
  Magnify: "Үлкейткіш",
  Zoom: "Үлкейту",
  Screen: "Скриншот",
  Rotate: "Айналдыру",
  Flip: "Айналдыру (көлденең)",
  Reset: "Қалпына келтіру",
  Eraser: "Өшіргіш",
  ArrowAnnotate: "A - Жебе белгісі",
  Bidirectional: "Қос бағытты",
  Angle: "Бұрыш",
  EllipticalROI: "E - Эллипс",
  FreehandRoi: "Қисық сызық",
  Length: "L - Сызғыш",
  Probe: "Нүкте арқылы белгі",
  RectangleRoi: "Тікбұрыш",
  TextMarker: "Мәтіндік белгі",
  DragProbe: "Зонд",
  ScaleOverlay: "Шкалалар",
  OrientationMarkers: "Бағыттаушы белгілер",
  Brush: "Қылқалам",
  CircleScissors: "Эллипс",
  FreehandScissors: "Еркін пішін",
  RectangleScissors: "Тікбұрыш",
  Invert: "Инверсия",
  Clip: "Автоайналдыру",
  Series: "Сериялар",
  Report: "Есеп",
  patientId: "Пациент ID",
  fullname: "Т.А.Ә.",
  birthday: "Туған күні",
  studyCreatedAt: "Зерттеу күні",
  old: "Жасы",
  patientSex: "Жынысы",
  "Result AI": "ЖИ нәтижесі",
  "Download dicom": "ЖИ серияларын жүктеу",
  "Download report": "Есепті жүктеу",
  Loading: "Жүктелуде",
  Cached: "кэште",
  male: "Ер",
  female: "Әйел",
  Copy: "Көшіру",
  "Copy ok": "Көшірілді",
  "Copy error": "Мәтінді көшіру мүмкін болмады",
  Anonymized: "Анонимделген",
  StackScroll: "Айналдыру",
  "Result after upload message":
    "Зерттеу өңделгеннен кейін есеп қолжетімді болады",
  "Result ai error message":
    "Зерттеуді өңдеу мүмкін болмады, басқа зерттеуді жүктеп көріңіз",
  error: "Қате",
  "dcm cannot loading": ".dcm файлдарын жүктеу мүмкін болмады",
  "error read dcm": "Зерттеуді оқу қатесі",
  ai: "ЖИ зерттеу",
  original: "Бастапқы зерттеу",
  "How to use title": "Қызметті пайдалану нұсқаулығы",
  "How to use": "Нұсқаулық",
  "ai accept caption": "Осы ЖИ талдауының нәтижесі дұрыс па?",
  "thx for feedback": "Кері байланыс үшін рахмет!",
  SelectedAccept: { 1: "Сіз нәтижені белгіледіңіз", 2: "ЖИ талдауы" },
  "accept yes": "дұрыс",
  "accept no": "дұрыс емес",
  "View title": "Зерттеу | " + process.env.VUE_APP_INSTALL_NAME,
  Share: "Бөлісу",
  "Share done": "Дайын",
  "Share about": "Сілтеме алмасу буферіне көшірілді",
  "Cancel preset": "Қалпына келтіру",
  Description: "Сипаттама",
  "About study": "Сіздің жауабыңыз",
  CheckReport: "Жіберу",
  "Your description": "Сіздің жауабыңыз",
  "Best description": "Үздік сипаттама",
  "Teacher comment": "Оқытушының пікірі",
  "Answer exist": "Аяқталды",
  "Answer not exist": "Жауап жоқ",
  from: "ішінен",
  "Skip all": "Барлығын өткізіп жіберу",
  "Add screenshot": "Скриншот жасау",
  "About screen info":
    "Сол жақтағы вьюер арқылы белгі жасап, скриншот қоса аласыз немесе файлды жүктей аласыз.",
  "Screenshot doned": "Дайын",
  PlanarFreehandROI: "R - Контур",
  MPR: "MPR",
  "Disable MPR First": "Алдымен MPR режимін сөндіріңіз",
  Crosshairs: "MIP және осьтер",
  "MPR: only for 2+": "MPR қолжетімсіз",
  "MPR: hpu tier == 0": "Құрылғы MPR үшін жеткіліксіз",
  "MPR: modality not support": "MPR <modality> модальділігімен жұмыс істемейді",
  "Cannot loading screen -- adblock":
    "Скриншотты жүктеу мүмкін болмады. VPN немесе жарнама блоктаушыларын сөндіріңіз",
  "Cannot loading screen -- s3 request":
    "Скриншотты жүктеу мүмкін болмады. Кейінірек қайталап көріңіз немесе қолдау қызметіне жазыңыз",
  "Cannot loading screen -- upload":
    "Скриншотты жүктеу мүмкін болмады. Кейінірек қайталап көріңіз немесе қолдау қызметіне жазыңыз",
  voi: "Жарықтық",
  camera: "Пан/зум",
  "Remove?": "Жою керек пе?",
  Support: "Қолдау",
  "Support info": "Сұрақ қоюға немесе мәселе туралы хабарлауға болады",
  "Send work?": "Сипаттаманы аяқтап, тексеруге жіберу?",
  shareAIResult:
    "ЖИ зерттеуді қалай өңдегенін көріңіз “" +
    process.env.VUE_APP_INSTALL_NAME +
    "”:",
  "Edit study": "Жауапты түзету",
};
